import Repository from './Repository';
import TokenService from '../helpers/token';

const resource = `${Repository.defaults.erpUrl}`;

export default {
  async getTrailOfOrder(orderId) {
    const response = await Repository.get(`${resource}/v2/order/${orderId}/trail`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
};
